var $ = Object.defineProperty, N = Object.defineProperties;
var V = Object.getOwnPropertyDescriptors;
var u = Object.getOwnPropertySymbols;
var x = Object.prototype.hasOwnProperty, v = Object.prototype.propertyIsEnumerable;
var g = (o, e, r) => e in o ? $(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, l = (o, e) => {
  for (var r in e || (e = {}))
    x.call(e, r) && g(o, r, e[r]);
  if (u)
    for (var r of u(e))
      v.call(e, r) && g(o, r, e[r]);
  return o;
}, p = (o, e) => N(o, V(e));
var S = (o, e) => {
  var r = {};
  for (var i in o)
    x.call(o, i) && e.indexOf(i) < 0 && (r[i] = o[i]);
  if (o != null && u)
    for (var i of u(o))
      e.indexOf(i) < 0 && v.call(o, i) && (r[i] = o[i]);
  return r;
};
import { jsxs as Y, jsx as h } from "react/jsx-runtime";
import { useState as d, useEffect as A } from "react";
import B from "react-select";
import { CustomSelect as E } from "./style.es.js";
function D(H) {
  var f = H, {
    defaultOption: o = {},
    onChange: e,
    options: r = [],
    placeholder: i = "",
    styles: n = {}
  } = f, C = S(f, [
    "defaultOption",
    "onChange",
    "options",
    "placeholder",
    "styles"
  ]);
  const [w, s] = d(o), [b, m] = d(!1), [F, I] = d(!1);
  A(() => {
    s(o);
  }, [o]);
  const j = (c) => {
    s(c), e && e(c);
  }, O = p(l({}, n), {
    option: (c, a) => {
      var t;
      return l(p(l({}, c), {
        focus: () => I(a.isFocused),
        color: "var(--color-navy-400)",
        backgroundColor: a.isSelected ? "var(--color-green-light2) !important" : "var(--color-neutral-25)",
        padding: 10,
        textAlign: "left",
        justiftContent: "center",
        alignItems: "center",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
        cursor: "pointer",
        minHeight: "50px",
        fontSize: "16px",
        display: "flex"
      }), ((t = n.options) == null ? void 0 : t.call(n, c, a)) || {});
    },
    control: (c, a) => {
      var t;
      return l({
        display: "flex",
        border: "1px solid var(--color-navy-50)",
        color: "var(--color-navy-400)",
        backgroundColor: "var(--color-neutral-25)",
        height: "48px",
        borderRadius: "5px",
        fontSize: "16px",
        padding: "0"
      }, ((t = n.control) == null ? void 0 : t.call(n, c, a)) || {});
    },
    singleValue: (c, a) => {
      var t;
      return l({
        margin: 0,
        marginLeft: 0,
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap"
      }, ((t = n.singleValue) == null ? void 0 : t.call(n, c, a)) || {});
    },
    valueContainer: (c, a) => {
      var t;
      return l(p(l({}, c), {
        overflow: "visible",
        padding: "0",
        flexWrap: "nowrap",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }), ((t = n.valueContainer) == null ? void 0 : t.call(n, c, a)) || {});
    },
    placeholder: (c, a) => {
      var t;
      return l(p(l({}, c), {
        backgroundColor: "var(--color-neutral-25)",
        transition: "0.1s ease-out",
        transformOrigin: "left top",
        color: "var(--color-navy-400)",
        top: a.isFocused ? "4%" : "50%",
        fontSize: a.isFocused ? "10px" : "16px",
        transform: a.isFocused ? "translateY(-32%) scale(0.9)" : "translateY(-50%) scale(1)"
      }), ((t = n.placeholder) == null ? void 0 : t.call(n, c, a)) || {});
    }
  }), k = () => m(!0), z = () => m(!1);
  return /* @__PURE__ */ Y(E, { children: [
    /* @__PURE__ */ h("span", { className: `${b ? "focused" : "blured"} ${F ? "selected" : "not-selected"} select-placeholder`, children: i }),
    /* @__PURE__ */ h(B, p(l({}, C), { styles: O, classNamePrefix: "react-select", value: w, onChange: j, placeholder: i, options: r, onFocus: k, onBlur: z, components: {
      IndicatorSeparator: () => null
    } }))
  ] });
}
export {
  D as CustomSelect
};
//# sourceMappingURL=CustomSelect.es.js.map
